// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.leftMenu {
  position: relative;
  min-width: 160px;
  width: 160px;
  height: 100vh;
  max-height: 100vh;
  background-color: white;
  box-shadow: 0px 0px 8px rgba(42, 98, 149, 0.25);
  display: flex;
  flex-direction: column;
  padding: 56px 0;
  z-index: 2; }
  .leftMenu__logout {
    display: flex;
    align-items: center;
    background: #f3f4f6;
    padding: 8px 5px;
    margin: 0 15px; }
    .leftMenu__logout_svg {
      width: 20px;
      margin-right: 15px;
      cursor: pointer;
      transition: all 0.4s; }
      .leftMenu__logout_svg:hover {
        transform: scale(1.1); }
    .leftMenu__logout_text {
      display: flex;
      flex-direction: column;
      overflow: hidden;
      font-feature-settings: 'clig' off, 'liga' off;
      text-overflow: ellipsis;
      /* product/Headline 5 */
      font-family: Inter;
      font-size: 14px;
      font-style: normal;
      font-weight: 600; }
    .leftMenu__logout_status_admin {
      margin-top: 3px;
      padding: 2px 6px;
      border-radius: 2px;
      background: #ffdbbe;
      color: #FE6100; }
    .leftMenu__logout_status_worker {
      margin-top: 3px;
      padding: 2px 6px;
      background: #dbd4e1;
      border-radius: 2px;
      color: #735b8a; }
    .leftMenu__logout_status_superuser {
      margin-top: 3px;
      padding: 2px 6px;
      background: #b5f1b9;
      border-radius: 2px;
      color: #ad88cf; }
  .leftMenu__company {
    position: absolute;
    width: 100%;
    height: max-content;
    padding: 0 10px;
    bottom: 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center; }
    .leftMenu__company h2 {
      font-weight: 600;
      font-size: 12px;
      line-height: 24px;
      color: #666666;
      margin-bottom: 5px; }
    .leftMenu__company h3 {
      width: 100%;
      text-align: center;
      font-weight: 600;
      font-size: 10px;
      line-height: 24px;
      color: #fe6100;
      background: #ffd1b4;
      padding: 2px;
      border-radius: 2px; }
  .leftMenu ul {
    padding: 0;
    display: flex;
    flex-direction: column;
    height: calc(100% - 70px);
    width: 100%;
    overflow: hidden auto; }
  .leftMenu a {
    display: flex;
    align-items: center;
    list-style-type: none;
    text-decoration: none;
    padding: 15px 0 15px 12px; }
    .leftMenu a svg {
      width: 15px;
      height: 15px;
      fill: #666666;
      transition: all 0.4s;
      margin-right: 12px; }
    .leftMenu a span {
      font-weight: 400;
      font-size: 14px;
      line-height: 24px;
      letter-spacing: 0.1px;
      transition: all 0.4s; }
  .leftMenu .noActiveMenu {
    background: white;
    cursor: pointer;
    transition: all 0.5s; }
    .leftMenu .noActiveMenu:hover {
      background: rgba(254, 97, 0, 0.1); }
      .leftMenu .noActiveMenu:hover span {
        color: #fe6100; }
      .leftMenu .noActiveMenu:hover svg {
        fill: #fe6100; }
    .leftMenu .noActiveMenu svg {
      fill: #666666; }
    .leftMenu .noActiveMenu span {
      color: #666666; }
  .leftMenu .activeMenu {
    background: rgba(254, 97, 0, 0.1); }
    .leftMenu .activeMenu svg {
      fill: #fe6100; }
    .leftMenu .activeMenu span {
      color: #fe6100; }
  .leftMenu hr {
    width: calc(100% - 20px);
    margin: 10px;
    text-align: center;
    color: #e0e0e0;
    border: 0.7px solid #e0e0e0; }
  @media screen and (max-width: 768px) {
    .leftMenu {
      display: none; } }
`, "",{"version":3,"sources":["webpack://./src/components/leftMenu/styles.scss"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,uBAAuB;EACvB,+CAA+C;EAC/C,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,UAAU,EAAA;EACV;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc,EAAA;IAEd;MACE,WAAW;MACX,kBAAkB;MAClB,eAAe;MACf,oBAAoB,EAAA;MAJrB;QAMG,qBAAqB,EAAA;IAGzB;MACE,aAAa;MACb,sBAAsB;MACtB,gBAAgB;MAChB,6CAA6C;MAC7C,uBAAuB;MACvB,uBAAA;MACA,kBAAkB;MAClB,eAAe;MACf,kBAAkB;MAClB,gBAAgB,EAAA;IAElB;MACE,eAAe;MACf,gBAAgB;MAChB,kBAAkB;MAClB,mBAAmB;MACnB,cACF,EAAA;IACA;MACE,eAAe;MACf,gBAAgB;MAChB,mBAAmB;MACnB,kBAAkB;MAClB,cAAc,EAAA;IAEhB;MACE,eAAe;MACf,gBAAgB;MAChB,mBAAmB;MACnB,kBAAkB;MAClB,cAAc,EAAA;EAGlB;IACE,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB,EAAA;IATnB;MAWG,gBAAgB;MAChB,eAAe;MACf,iBAAiB;MACjB,cAAc;MACd,kBAAkB,EAAA;IAfrB;MAkBG,WAAW;MACX,kBAAkB;MAClB,gBAAgB;MAChB,eAAe;MACf,iBAAiB;MACjB,cAAc;MACd,mBAAmB;MACnB,YAAY;MACZ,kBAAkB,EAAA;EAxFxB;IA4FI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,WAAW;IACX,qBAAqB,EAAA;EAjGzB;IAoGI,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,qBAAqB;IACrB,yBAAyB,EAAA;IAxG7B;MA0GM,WAAW;MACX,YAAY;MACZ,aAAa;MACb,oBAAoB;MACpB,kBAAkB,EAAA;IA9GxB;MAiHM,gBAAgB;MAChB,eAAe;MACf,iBAAiB;MACjB,qBAAqB;MACrB,oBAAoB,EAAA;EArH1B;IAyHI,iBAAiB;IACjB,eAAe;IACf,oBAAoB,EAAA;IA3HxB;MA6HM,iCAAiC,EAAA;MA7HvC;QA+HQ,cAAc,EAAA;MA/HtB;QAkIQ,aAAa,EAAA;IAlIrB;MAsIM,aAAa,EAAA;IAtInB;MAyIM,cAAc,EAAA;EAzIpB;IA6II,iCAAiC,EAAA;IA7IrC;MA+IM,aAAa,EAAA;IA/InB;MAkJM,cAAc,EAAA;EAlJpB;IAsJI,wBAAwB;IACxB,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,2BAA2B,EAAA;EAG7B;IA7JF;MA8JI,aAAa,EAAA,EAEhB","sourcesContent":[".leftMenu {\n  position: relative;\n  min-width: 160px;\n  width: 160px;\n  height: 100vh;\n  max-height: 100vh;\n  background-color: white;\n  box-shadow: 0px 0px 8px rgba(42, 98, 149, 0.25);\n  display: flex;\n  flex-direction: column;\n  padding: 56px 0;\n  z-index: 2;\n  &__logout {\n    display: flex;\n    align-items: center;\n    background: #f3f4f6;\n    padding: 8px 5px;\n    margin: 0 15px;\n\n    &_svg {\n      width: 20px;\n      margin-right: 15px;\n      cursor: pointer;\n      transition: all 0.4s;\n      &:hover {\n        transform: scale(1.1);\n      }\n    }\n    &_text {\n      display: flex;\n      flex-direction: column;\n      overflow: hidden;\n      font-feature-settings: 'clig' off, 'liga' off;\n      text-overflow: ellipsis;\n      /* product/Headline 5 */\n      font-family: Inter;\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 600;\n    }\n    &_status_admin {\n      margin-top: 3px;\n      padding: 2px 6px;\n      border-radius: 2px;\n      background: #ffdbbe;\n      color:#FE6100\n    }\n    &_status_worker{\n      margin-top: 3px;\n      padding: 2px 6px;\n      background: #dbd4e1;\n      border-radius: 2px;\n      color: #735b8a;\n    }\n    &_status_superuser {\n      margin-top: 3px;\n      padding: 2px 6px;\n      background: #b5f1b9;\n      border-radius: 2px;\n      color: #ad88cf;\n    }\n  }\n  &__company {\n    position: absolute;\n    width: 100%;\n    height: max-content;\n    padding: 0 10px;\n    bottom: 40px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    h2 {\n      font-weight: 600;\n      font-size: 12px;\n      line-height: 24px;\n      color: #666666;\n      margin-bottom: 5px;\n    }\n    h3 {\n      width: 100%;\n      text-align: center;\n      font-weight: 600;\n      font-size: 10px;\n      line-height: 24px;\n      color: #fe6100;\n      background: #ffd1b4;\n      padding: 2px;\n      border-radius: 2px;\n    }\n  }\n  ul {\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n    height: calc(100% - 70px);\n    width: 100%;\n    overflow: hidden auto;\n  }\n  a {\n    display: flex;\n    align-items: center;\n    list-style-type: none;\n    text-decoration: none;\n    padding: 15px 0 15px 12px;\n    svg {\n      width: 15px;\n      height: 15px;\n      fill: #666666;\n      transition: all 0.4s;\n      margin-right: 12px;\n    }\n    span {\n      font-weight: 400;\n      font-size: 14px;\n      line-height: 24px;\n      letter-spacing: 0.1px;\n      transition: all 0.4s;\n    }\n  }\n  .noActiveMenu {\n    background: white;\n    cursor: pointer;\n    transition: all 0.5s;\n    &:hover {\n      background: rgba(254, 97, 0, 0.1);\n      span {\n        color: #fe6100;\n      }\n      svg {\n        fill: #fe6100;\n      }\n    }\n    svg {\n      fill: #666666;\n    }\n    span {\n      color: #666666;\n    }\n  }\n  .activeMenu {\n    background: rgba(254, 97, 0, 0.1);\n    svg {\n      fill: #fe6100;\n    }\n    span {\n      color: #fe6100;\n    }\n  }\n  hr {\n    width: calc(100% - 20px);\n    margin: 10px;\n    text-align: center;\n    color: #e0e0e0;\n    border: 0.7px solid #e0e0e0;\n  }\n\n  @media screen and (max-width: 768px) {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
